import React from "react";
import { findDOMNode } from "react-dom";
import ModalPinnedBlock from "./blocks/pinned-block";
import ModalStarredBlock from "./blocks/starred-block";
import SettingsSearch from "../../../../../layout/search/sections/settings/settings-search";
import SettingsModule from "../../../../modules/settings-module";
import asyncSessionLoader from "../../../../gd/data/async-session-loader";
import {ViewTypeConfigs} from "../../../../gd/const/views/view-type-config";
import {ViewType} from "../../../../gd/const/views/view-type";
import SearchList from "./search-list";

type State = {
    search           : string
    isSearching      : boolean
    currentCursorKey : any | null
}

type Props = {
    navigation   : any
    onClick      : callback
    onSubmit     : callback
    onCloseModal : callback
    className    : string
}

export default class ModalGoToMain extends React.Component<Props, State> {

    public delayedSearch     : any
    public options           : any
    public optionsReference  : any
    public input             : any
    public main              : any
    public projects          : any
    public views             : any
    public users             : any
    public tasks             : any
    public notes             : any
    public settings          : SettingsModule[]        = []

    constructor(props: Props) {
        super(props);

        this.delayedSearch = _.debounce(this.quickSearch, 500);

        this.options = [];
        this.optionsReference = React.createRef();

        this.state = {
            search: "",
            isSearching: true,
            currentCursorKey : null
        }

        this.clearData();
    }

    componentDidMount() {
        //timeout for focus because shortcut appeared in it right away
        if (this.input) setTimeout(()=>{this.input.focus()}, 0);
    }

    componentDidUpdate() {
        const key = this._getCurrentOptionKey();

        if (this.optionsReference[key]) {
            const mainNode = findDOMNode(this.main);
            const node = findDOMNode(this.optionsReference[key]);
            // @ts-ignore
            mainNode.scrollTop = node.offsetTop - (mainNode.clientHeight - node.clientHeight)/2;
        }
    }

    componentWillUnmount() {
        this.delayedSearch.cancel();
    }

    clearData = () => {
        this.projects = [];
        this.views = [];
        this.users = [];
        this.tasks = [];
        this.notes = [];
        this.settings = []
    }

    _getProjectKey  = (project: any) => "project_"+project.id
    _getViewKey     = (view: any) => "view_"+view.id+"_"+view.type
    _getUserKey     = (companyUser: any) => "user_"+companyUser.id
    _getTaskKey     = (task: any) => "task_"+task.id
    _getNoteKey     = (note: any) => "note_"+note.id
    _getSettingKey  = (setting: any) => "setting_"+(setting.url || setting.settingsUrl)

    _updateOptions = () => {
        this.options = _.union(
            this.projects.map((p: any)=>this._getProjectKey(p)),
            this.views.map((v: any)=>this._getViewKey(v)),
            this.users.map((cu: any)=>this._getUserKey(cu)),
            this.tasks.map((t: any)=>this._getTaskKey(t)),
            this.settings.map((p: any)=>this._getSettingKey(p)),
        );
    }

    _getCurrentOptionKey = () => {
        const { currentCursorKey } = this.state;
        return !_.isNil(currentCursorKey) ? this.options[currentCursorKey] : null;
    }

    onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value ? event.target.value : '';
        const search = value ? value.trim().toLowerCase() : '';

        this.clearData();

        if (search) {
            gd.session.projects.map((p: any)=>{if (!p.isTemplate && p.access && (p.name.toLowerCase().includes(search) || p.id === value)) this.projects.push(p)});

            _.map(gd.session.customViews.models, b=>{if (b.name.toLowerCase().includes(search)) this.views.push(b)});

            gd.session.companyUsers.map((cu: any)=>{if (cu.user.name.toLowerCase().includes(search)) this.users.push(cu)});

            this.projects   = _.orderBy(this.projects, p=>p.name.toLowerCase())
            this.views      = _.orderBy(this.views, v=>v.name.toLowerCase())
            this.users      = _.orderBy(this.users, cu=>cu.user.name.toLowerCase())

            this.settings   = new SettingsSearch(true, false, false).search(search);

            this._updateOptions()
        }

        this.setState({
            search: value,
            isSearching: true
        }, ()=>{
            this.delayedSearch();
        })
    }

    onSearchCancel = () => {
        this.clearData();
        this.setState({
            search: ''
        })
    }

    quickSearch = async ()=> {
        if (!this.state.search) return false;

        try {
            const response = await gd.api.Search.quick(this.state.search);
            await gd.session.noteTypes;

            this.tasks = _.get(response, 'result.tasks', []);
            this.tasks = _.orderBy(this.tasks, t=>t.title.toLowerCase());
            this.notes = _.get(response, 'result.notes', []);
            this.notes = _.orderBy(this.notes, t=>t.name.toLowerCase());

            await asyncSessionLoader(this.findMissingData())

            this._updateOptions();
            this.setState({ isSearching: false });

        }catch (e: any){
            console.error(e)
            this.tasks = [];
            this.notes = [];
            this._updateOptions();
            this.setState({ isSearching: false });
        }
    }

    findMissingData() {
        const allProjectsIds: any = [];
        const allTaskTypeIds: any = [];
        _.map(this.tasks, task=>{
            allProjectsIds.push(task.projectId)
            allTaskTypeIds.push(task.taskTypeId)
        });

        const allNoteTypesIds: any = [];
        _.map(this.notes, note=>{
            allProjectsIds.push(note.projectId)
            allNoteTypesIds.push(note.noteTypeId)
        });

        return gd.session.findMissing({
            projects: _.uniq(allProjectsIds),
            taskTypes: _.uniq(allTaskTypeIds),
            noteTypes: _.uniq(allNoteTypesIds)
        });
    }

    onClickProject = (id: ID) =>                {this.props.onCloseModal(); gd.goTo('p/'+id);}

    onClickView = (id: ID, type: ID) =>         {
        this.props.onCloseModal()
        gd.session.customViews.get(id)?.open()
    }

    onClickUser = (companyUserId: ID) =>        {this.props.onCloseModal(); gd.goTo('u/'+companyUserId);}
    onClickTask = (id: ID) =>                   {this.props.onCloseModal(); gd.goTo('t/'+id);}
    // onClickNote = (id: ID) =>                   {this.props.onCloseModal(); gd.goTo('n/'+id);}
    // onClickSetting = (url: string) =>           {this.props.onCloseModal(); gd.goTo(url)}

    onPopoverKeyDown = (event: React.KeyboardEvent) => {

        let newValue;
        switch(event.key) {
            case 'Escape': this.props.onCloseModal(); break;

            case 'ArrowUp':
                if (this.state.currentCursorKey === null) {
                    newValue = 0;
                } else {
                    newValue = this.state.currentCursorKey - 1;
                    if (newValue < 0) newValue = 0;
                }

                this.setState({currentCursorKey: newValue});
                break;

            case 'ArrowDown':
                if (this.state.currentCursorKey === null) {
                    newValue = 0;
                } else {
                    newValue = this.state.currentCursorKey + 1;
                    if (newValue > this.options.length - 1) newValue = this.options.length - 1;
                }

                this.setState({currentCursorKey: newValue});
                break;

            case 'Enter':
                const currentOptionKey = this._getCurrentOptionKey();
                if (currentOptionKey) {
                    const selectedOption = currentOptionKey.split('_') ;
                    switch(selectedOption[0]) {
                        case 'project': this.onClickProject(selectedOption[1]); break;

                        case 'view':
                            this.onClickView(selectedOption[1], ViewTypeConfigs[selectedOption[2] as ViewType]!.url!)
                            break

                        case 'user':    this.onClickUser(selectedOption[1]); break;
                        case 'task':    this.onClickTask(selectedOption[1]); break;
                    }
                }
                break;
        }
    }

    renderHeader() {
        return (
            <div className="header">
                {this.props.navigation}
                <div className="search">
                    <input ref          = {r=>this.input = r}
                           className    = "gd-input big"
                           type         = "input"
                           placeholder  = "Task title or #, project name or #, view, user, setting name"
                           value        = {this.state.search}
                           onChange     = {this.onSearchChange}/>
                    <div className="i5-search"/>
                    {!!this.state.search && <div className="i5-delete" onClick={this.onSearchCancel}/>}
                </div>

                <div className="i5-delete" onClick={this.props.onCloseModal}/>
            </div>
        )
    }

    render = ()=>  {

        const isCustomerPortal  = gd.user.acl.isClient
        const isGuest           = gd.user.acl.isGuest

        const noMatches =
            this.projects.length === 0 &&
            this.views.length === 0 &&
            this.users.length === 0 &&
            this.tasks.length === 0 &&
            this.notes.length === 0 &&
            this.settings.length === 0 &&
            !this.state.isSearching;

        return (
            <div className={Classes("go-to", this.props.className)} onClick={this.props.onClick} onKeyDown={this.onPopoverKeyDown}>
                {this.renderHeader()}

                {!this.state.search &&
                    <div ref={r=>this.main = r} className="main default">
                        <div className="blocks">
                            <ModalPinnedBlock onCloseModal={this.props.onCloseModal}/>
                            <ModalStarredBlock onCloseModal={this.props.onCloseModal}/>
                        </div>
                        <div className="keyboard-shortcut"><div className="icon i5-keyboard"/> <div className="shortcut-button">G</div></div>
                    </div>}

                {!!this.state.search &&
                    <div ref={r=>this.main = r} className="main">

                        <SearchList noMatches           = {noMatches}
                                    isGuest             = {isGuest}
                                    isCustomerPortal    = {isCustomerPortal}
                                    isSearching         = {this.state.isSearching}
                                    projects            = {this.projects}
                                    views               = {this.views}
                                    users               = {this.users}
                                    tasks               = {this.tasks}
                                    notes               = {this.notes}
                                    settings            = {this.settings}
                                    getProjectKey       = {this._getProjectKey}
                                    getViewKey          = {this._getViewKey}
                                    getUserKey          = {this._getUserKey}
                                    getTaskKey          = {this._getTaskKey}
                                    getNoteKey          = {this._getNoteKey}
                                    getSettingKey       = {this._getSettingKey}
                                    onCloseModal        = {this.props.onCloseModal}
                                    getCurrentOptionKey = {this._getCurrentOptionKey}/>

                    </div>}
            </div>
        )
    }
}
